import { Injectable } from '@angular/core';

@Injectable()
export class DataService {

  private primaryColor = '#c00000';

  private allProjects = [];
  constructor() {
  }

  // TODO: revisar, ya no se usa?
  getBrowserOptions() {
    return {
      statusbar: {
        color: this.primaryColor,
      },
      toolbar: {
        height: 45,
        color: this.primaryColor,
      },
      title: {
        color: '#ffffffff',
        showPageTitle: true,
      },
      closeButton: {
        image: 'back',
        imagePressed: 'back',
        align: 'left',
        event: 'closePressed',
      },
      customButtons: [
        {
          image: 'share',
          imagePressed: 'share_pressed',
          align: 'right',
          event: 'sharePressed',
        },
      ],
      backButtonCanClose: true,
      transitionstyle: 'crossdissolve',
    };
  }

  // TODO: revisar, ya no se usa?
  getBrowserOptionsAndroid() {
    return this.getBrowserOptions();
  }

  setColourStatusSuggest(color, status, type?) {
    const sheet = document.createElement('style');

    let html = '.card-' + status;
    if (type) {
      html += ' {background-color: ' + color + ' !important;}';
      html += '.title-status-' + status + ' {color: ' + color + ' !important;}';
    } else {
      html += ' {color: ' + color + ' !important;}';
    }

    sheet.innerHTML = html;
    document.body.appendChild(sheet);
  }

  setColourStatusProfileContainer(color) {
    const sheet = document.createElement('style');
    let html = 'div.right:after';
    html += ' {background: ' + color + ' !important;}';
    html += '.right {background: ' + color + ' !important;}';
    sheet.innerHTML = html;
    document.body.appendChild(sheet);
  }

  insertCustomCSS(config, change?) {
    this.primaryColor = config.primary_color;
    const sheet = document.createElement('style');
    // background-color primary
    let html = 'ion-navbar .toolbar-background, .container-header, .toolbar-md-alfatec .toolbar-background-md, .alfatecBGColor, .segment-bar,.badgeHome, .tab-item, td.confirm, button.fab, div.nav, ' +
      '.profile-container, .profile-status-container, .titulo-step, .add-files, .deleteButtonRecordDay, .footerCalendar, calendarModalPage ion-calendar ion-calendar-month .primary .days .on-selected, ' +
      'timeoff-request .add-files, .statusCovid, .add-files, .checkbox-md-alfatec, .checkbox-checked, .radio-md-alfatec .radio-inner, .skillSelected:hover:not(.disable-hover), .skillSelected:not(.disable-hover), .skillSelected:hover,' +
      '.skillSelected';
    html += ' { background-color: ' + config.primary_color + ' !important;}';
    // color primary
    html += '.containStatus:before { background: white !important;}';
    html += 'p.logout, .container-logout, .haveStatus, .europass, .containerTimeHours, calendarModalPage ion-calendar ion-calendar-month .primary .days .today p, .points, ' +
      '.flecha, .timeoff-request .containerTimeHours2 input { color: ' + config.primary_color + ' !important;}';

    // Color's modal popu 10 points
    html += '.lottie div svg g g:nth-child(1) g:nth-child(odd) path { fill: ' + config.primary_color + ' !important; fill-opacity: 0.8 !important;}';
    html += '.lottie div svg g g:nth-child(1) g:nth-child(even) path { fill: ' + config.primary_color + ' !important;}';
    // logos
    let logoHeaderUrl = config.logo_header;
    if (config.logo_header == null) logoHeaderUrl = 'assets/icon/logo-fuifi.svg';
    html += ".logoEmpresa, .logoEmpresa::after { content: url('" + logoHeaderUrl + "') !important; width: 100% !important; height: 65% !important; object-fit: contain;}"; // height: 35px !important;
    html += '.toolbar-title-ios, .toolbar-title {height: 100% !important;}';
    // gradient primary
    html +=
      '.suggestion-type { background: linear-gradient(180deg, ' +
      config.primary_color + ' 60%, white 40%) !important;} ';

    // color + background-color dark
    html += '.profile-subtitle, .profile-score-subtitle,  .ic-suggestion-selected, ion-icon.ic-academy-active, ion-icon.ic-activity-active, ion-icon.ic-installation-active, ion-icon.ic-process-active, ion-icon.ic-innovation-active, ion-icon.ic-client-active, ion-icon.ic-candidate-active, ion-icon.ic-prl-active, ion-icon.ic-advantaje-active, ion-icon.ic-app-active { color: ' + config.primary_color_dark + ' !important;}';
    html += '.rectangle, td.cancel_timeoff, .cancelDark { background-color: ' + config.primary_color_dark + ' !important;}';
    html += '.location, .checkbox-md-alfatec .checkbox-checked { border: solid 1px ' + config.primary_color_dark + ' !important;}';

    // TABS
    const greyColor = '#32353a';
    const arrayTabs = ['tab-inicio', 'tab-formacion', 'tab-ventajas', 'tab-office', 'tab-register'];

    html += 'ion-icon[class*="iconcolor-suitcase"] { color: ' + config.primary_color_dark + '!important;}';
    html += 'ion-icon[class*="iconcolor-podium1"], ion-icon[class*="iconcolor-logout"], ion-icon[class*="iconcolor-statusClear"] { color: ' + config.primary_color + '!important;}';
    html += '.tabs .tab-button { color: ' + greyColor + '!important;}';
    html += '.tabs .tab-button[aria-selected=true] { color: ' + (config.company_name == 'WAM2' ? config.primary_color_dark : config.primary_color) + '!important;}';

    arrayTabs.forEach((element) => {
      html += '.tabs-md .tab-button[aria-selected=false] .tab-button-icon.ion-md-' + element + ':before, .ion-ios-' + element + '-outline:before  ,.ion-md-' + element + '-outline:before { color: ' + greyColor + ' !important; }';
      html += '.' + element + ' :before , .ion-ios-' + element + ':before , .ion-md-' + element + ':before { color: ' + (config.company_name == 'WAM2' ? config.primary_color_dark : config.primary_color) + ' !important; }';
    });

    let logoUrlDefault = 'assets/icon/ic-fuifi.svg';
    if (config.favicon != null) logoUrlDefault = config.favicon;

    let logoUrlSelected = 'assets/icon/ic-fuifi-selected.svg';
    if (config.favicon_selected != null) logoUrlSelected = config.favicon_selected;

    html +=
      ".ion-ios-company-outline,   .tabs-md .tab-button[aria-selected=false] .tab-button-icon.ion-md-company, .tab-button-icon.ion-md-company::after { background: url('" +
      logoUrlDefault + "') !important; content: none !important; object-fit: contain; width: 9%; height: 24px !important; background-size: 100% 100% !important;}"; // width: 24px !important; height: 24px !important;
    html +=
      ".ion-ios-company,          .tabs-md .tab-button[aria-selected=true] .tab-button-icon.ion-md-company, .tabs-md .tab-button[aria-selected=true] .tab-button-icon.ion-md-company::after { background: url('" +
      logoUrlSelected + "') !important; content: none !important; object-fit: contain; width: 9%; height: 24px !important; background-size: 100% 100% !important;}"; // width: 24px !important; height: 24px !important;
    // fin TABS

    // Color swipe pagination active bullet
    html += 'user-tutorial .swiper-pagination-bullet-active{ background-color:' +
      config.primary_color + ' !important}';

    // Color webkit-scrollbar
    html += '.webscroll ::-webkit-scrollbar-thumb, .webscroll ::-webkit-scrollbar-thumb:window-inactive';
    html += ' { background-color: ' + config.primary_color + ' !important;}';

    sheet.innerHTML = html;
    document.body.appendChild(sheet);
  }

  addProjects(data:any){
    this.allProjects= [this.allProjects, ...data];
  }
  deleteProjects(){
    this.allProjects = [];
  }
}



// WEBPACK FOOTER //
// ./src/services/data.service.ts